<template>
<div class="px-1">
	<h5 class="fw-bold fs-5 mb-2">Таблиця сповіщень</h5>
	<p class="mb-2 paragraph-indent">
		Таблиця показує сповіщення станцій за вибраний період часу. Нижче подано значення кожного стовпчика.
	</p>

	<ul class="mb-2">
		<li>
			<strong>Станція</strong> - назва станції, яка надіслала сповіщення.
		</li>
		<li v-if="accountStore.isPrimary">
			<strong>Організація</strong> - назва організації станції.
		</li>
		<li>
			<strong>Час</strong> - дата і час фіксації сповіщення.
		</li>
		<li>
			<strong>Клас</strong> - категорія сповіщення: <strong>охорона</strong>, <strong>захист</strong> або <strong>стан</strong>.
		</li>
		<li>
			<strong>Тип</strong> - джерело/канал спрацювання:
			канали 1-2, контури 1-6, шунт, 220 В.
			Запис з "повернувся" означає повернення до штатного стану.
		</li>
		<li>
			<strong>Значення</strong> - стан події, наприклад:
			"КЗ в контурі", "контур розімкнуто", "вихід за нижню межу",
			"контур вихід за верхню межу", "повернувся до нормального стану".
		</li>
		<li>
			<strong>Номінал</strong> - порогове (номінальне) значення, відносно якого зафіксовано відхилення.
			Для окремих типів сповіщень може бути порожнім.
		</li>
		<li>
			<strong>Лічильник</strong> - порядковий номер/лічильник спрацювань конкретного типу сповіщення на станції.
		</li>
	</ul>

	<p class="mb-0 paragraph-indent fst-italic">
		Для стовпчиків "Організація", "Клас" і "Тип" доступні фільтри у заголовках таблиці.
	</p>
</div>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore.js'


export default {
	components: {},

	setup() {
		const accountStore = useAccontStore()

		return {
			accountStore,
		}
	},
}
</script>
